class ExternalVideoPlayer extends HTMLElement {
  constructor() {
    super();
    const template = this.querySelector('template');
    if (!template) return;
    this.addEventListener('click', () => {
      const externalVideoPopup = document.createElement('div');
      externalVideoPopup.classList.add('external-video-popup');
      const externalVideoPopupContent = document.createElement('div');
      externalVideoPopupContent.classList.add('external-video-popup__content');
      const externalVideoPopupClose = document.createElement('div');
      externalVideoPopupClose.classList.add('external-video-popup__close');
      externalVideoPopupClose.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                    <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                </svg>
            `;
      externalVideoPopupContent.appendChild(externalVideoPopupClose);
      externalVideoPopupContent.appendChild(template.content.cloneNode(true));
      externalVideoPopup.appendChild(externalVideoPopupContent);
      document.body.appendChild(externalVideoPopup);
      externalVideoPopup.addEventListener('click', e => {
        if (e.target.contains(externalVideoPopup) || externalVideoPopupClose.contains(e.target)) {
          externalVideoPopup.remove();
        }
      });
    });
  }

}

customElements.define('external-video-player', ExternalVideoPlayer);
